/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import { SetStockAdjustmentList, GetStockAdjustmentList } from "../../store/stockAdjustmentAtom";
import { SetStockOpeningList, GetStockOpeningList } from "../../store/stockOpeningAtom";
import CurrencyFormat from "react-currency-format";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { stockService } from "../../services/stockService";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { stockOpeningService } from "../../services/stockOpening.service";

const StockOpeningMainPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext); // Select only needed context value
 
  const setStockData  = SetStockOpeningList();
  const getStockData  = GetStockOpeningList();
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const [searchText, setSearchText] = useState("");
  

  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: "Ref",
        key: "ref_no",
        dataIndex: "ref_no",
        className: "text-primary",
        sorter: (a, b) => (a?.ref_no ?? "") - (b?.ref_no ?? ""),
      },
     
      {
        title: "Warehouse",
        dataIndex: "warehouse_name",
        sorter: (a, b) => (a?.warehouse_name ?? "").localeCompare(b?.warehouse_name ?? ""),
      },

  
      {
        title: "Create Date",
        dataIndex: "encoded_date",
        sorter: (a, b) => (a?.encoded_date ?? 0) - (b?.encoded_date ?? 0),
        render: (record) => <span>{formatCustomDate(record)}</span>,
      },
      {
        title: "Created By",
        dataIndex: "encoded_by_name",
        sorter: (a, b) => (a?.encoded_by_name ?? "").localeCompare(b?.encoded_by_name ?? ""),
      },
    
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    if (getStockData?.stock_opening_info?.length > 0) {
      setTableData(getStockData?.stock_opening_info);
    }else{
      getStockListFromAPI();
    }
    return () => {
    };
  }, []);


  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getStockListFromAPI();
    }
  }, []);


  // Fetch sales order list with abortable request
  const getStockListFromAPI = useCallback(async () => {
   
    try {
      const response = await stockOpeningService.stockOpeningList();
      const serverData =  response.data;
      if ( serverData !== undefined) {
        const stock_opening_info = serverData?.stock_opening_info?.length ?  serverData?.stock_opening_info : [];
        const warehouse = serverData?.warehouse?.length ?  serverData?.warehouse : [];
        setStockData({...serverData, stock_opening_info: stock_opening_info, warehouse:warehouse });
      setTableData(response.data?.stock_opening_info || []);

        
      }
    } catch (err) {
        console.error(err);
    }
   
  }, []);





  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);

  const addNewStockOpening = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [currModuleId, currModuleName, currUserMenu, navigate]);



  const handleRowClick = useCallback(
    (data) => {
      const id = data["ref_no"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );



  const onClearInput = ()=> {
    setSearchText("");
    setTableData(getStockData?.stock_opening_info || []);

   }



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(getStockData?.stock_opening_info || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (getStockData?.stock_opening_info || []).filter(credit =>
       Object.values(credit).some(value => 
         value?.toString().toLowerCase().includes(searchTerm)
       )
     );
     setTableData(filtered); 
   };

  return (
    <>
  
      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-2">
          {/* {itemSelected.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>
              <Dropdown.Menu>
                {salesOrderData["Bulk_Action"]?.map((action, i) => (
                  <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                    {action.Action_Name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <SalesOrderFilter list={salesOrderData["Filtering_Criteria"]} onFilterSelect={onFilterSelect} />
          )} */}
          <Tooltip title="Reload">
            <div
              onClick={getStockListFromAPI}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

     

        <div className="flex items-center space-x-4">
          <Tooltip title="Add New">
            <button
              onClick={addNewStockOpening}
              className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
            >
              <FaPlus className="h-[16px] w-[16px] text-gray-600" />
            </button>
          </Tooltip>
        </div>

      </div>

                  {/* Start of search */}
    <div className="flex justify-center mt-4">
 
  </div>
  {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.Sales_Order_Ref_No}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default React.memo(StockOpeningMainPage); // Memoize component